import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { ProgramDispensingHistoryUploadPage } from '../program-dispensing-history-upload/program-dispensing-history-upload';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';
import { Subject } from 'rxjs';

/**
 * Generated class for the ProgramDispensingHistoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-program-dispensing-history',
  templateUrl: 'program-dispensing-history.html',
})
export class ProgramDispensingHistoryPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  userid: any;
  user_fullname: any;
  program_name: any;
  program_id: any;

  dispensing: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private auth: AuthProvider,
    private modalCtrl: ModalController,
    private database: DatabaseProvider,
    public utility: UtilityProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.userid = user.id;
      this.user_fullname = user.first_name + ' ' + user.last_name;
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.database.getDispensingFromProgram(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((dispensing) => {
        console.log('dispensing: ', dispensing);
        this.dispensing = dispensing;
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave program dispensing and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  uploadHistory()  {
    let uploadModal = this.modalCtrl.create(ProgramDispensingHistoryUploadPage, null, {showBackdrop: true, enableBackdropDismiss: false});
    uploadModal.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/program-dispensing-history/program-dispensing-history.ts